import React, { useRef, useState, useEffect } from 'react';
import type { LottiePlayer } from 'lottie-web';
import styles from './success-animation.module.scss';
import SuccessAnimation from '../../../assets/lotties/successAnimation.json';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const SuccessAnimationComponent = () => {
  const lottie = useRef<LottiePlayer>(undefined);
  const animationRef = useRef<HTMLDivElement>(null);
  const animationLoadedRef = useRef(false);
  const [animationLoaded, setAnimationLoaded] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const performAnimation = async () => {
      if (!lottie.current) lottie.current = (await import('lottie-web')).default;

      if (animationRef.current && !animationLoadedRef.current) {
        animationLoadedRef.current = true;
        const lottieAnimation = lottie.current.loadAnimation({
          container: animationRef.current,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          animationData: SuccessAnimation,
          rendererSettings: {
            preserveAspectRatio: 'none',
            viewBoxOnly: true,
          },
        });
        lottieAnimation.addEventListener('DOMLoaded', () => setAnimationLoaded(true));
        lottieAnimation.addEventListener('complete', () => navigate('/factoring'));

        return () => lottieAnimation.destroy();
      }
    };

    performAnimation();

    // Cleanup reference on component unmount
    return () => {
      animationLoadedRef.current = null;
    };
  }, [animationRef, navigate]);

  return (
    <section className={styles.final_animation_wrapper}>
      <div className={styles.container}>
        <div className={styles.anim_container}>
          <div className={styles.anim} ref={animationRef} />
          {animationLoaded && (
            <div className={styles.anim_text_container}>
              <div className={styles.anim_primary_text}>{t('thank_you_for_submitting')}</div>
              <div className={styles.anim_secondary_text}>{t('your_application_will_be_reviewed')}</div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default SuccessAnimationComponent;
